'use client';

import { useEffect } from 'react';

import { DOMAINS } from '@/helpers/constants';

export const useLicenseScript = () => {
  useEffect(() => {
    try {
      const licenseScript =
        window.location.hostname === DOMAINS.OTHER
          ? //@ts-ignore
            window.apg_df94f8da_c877_459b_8c07_ef39854426db
          : //@ts-ignore
            window.apg_0aa16dab_6b0e_4c30_b208_c36d01701c3d;

      licenseScript?.init();
    } catch (err) {
      console.error(err);
    }
  }, []);
};
